import { render, staticRenderFns } from "./DialogCourseMessage.vue?vue&type=template&id=432ca1f8&scoped=true"
import script from "./DialogCourseMessage.vue?vue&type=script&lang=js"
export * from "./DialogCourseMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432ca1f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('432ca1f8')) {
      api.createRecord('432ca1f8', component.options)
    } else {
      api.reload('432ca1f8', component.options)
    }
    module.hot.accept("./DialogCourseMessage.vue?vue&type=template&id=432ca1f8&scoped=true", function () {
      api.rerender('432ca1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogCourseMessage.vue"
export default component.exports